import { Injectable, Renderer2 } from '@angular/core';
import { AlertController, ToastController, LoadingController, ModalController, Platform, IonicSafeString, PopoverController } from '@ionic/angular';
import { VideoPlayerComponent } from '../components/modals/video-player/video-player.component';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { File } from '@ionic-native/file/ngx';
import { HTTP } from '@ionic-native/http/ngx';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { SuaLetterService } from './sua-letter.service';
import { ImageViewComponent } from '../components/modals/image-view/image-view.component';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { Keyboard } from '@ionic-native/keyboard/ngx';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { Storage } from '@ionic/storage';
import { Network } from '@ionic-native/network/ngx';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';
import { YoutubePlayerComponent } from '../components/modals/youtube-player/youtube-player.component';
@Injectable({
  providedIn: 'root'
})

export class AlertService {
  loading: boolean = false;

  hasErr: any = false
  errorMsg = new BehaviorSubject("");
  errorExist = new BehaviorSubject(false);
  interval: any
  keyboardWillHideSubModal: Subscription;
  keyboardWillShowSubModal: Subscription;
  keyboardWillHideSubFab: Subscription;
  keyboardWillShowSubFab: Subscription;
  keyboardWillShowSubFooter: Subscription
  keyboardWillHideSubFooter: Subscription
  register_type$ = new BehaviorSubject<string | null>(null);
  options: any = []
  constructor(private androidPermissions: AndroidPermissions, private nativeHTTP: HTTP, private loadingCtrl: LoadingController, private toastController: ToastController, private alertController: AlertController, private modalController: ModalController, private socialSharing: SocialSharing, private file: File, public platform: Platform,
    private suaLetterService: SuaLetterService, private fileOpener: FileOpener,
    private keyboard: Keyboard, private device: Device, private storage: Storage,
    private network: Network, private iab: InAppBrowser

  ) { }
  async loadRegisterType() {
    const register_type = await this.storage.get('type_register');
    this.register_type$.next(register_type);
  }

  setRegisterType(register_type: string) {
    this.storage.set('register_type', register_type);
    this.register_type$.next(register_type);
  }

  // getRegisterType(): Observable<string|null> {
  //   return this.register_type$.asObservable();
  // }
  getRegisterType(): Observable<string | null> | any {
    if (!this.register_type$.value) {
      this.storage.get('register_type').then(register_type => {
        this.register_type$.next(register_type);
      });
    }
    return this.register_type$.value;
  }
  async presentToast(message: any) {
    const toast = await this.toastController.create({
      message: message,
      duration: 5000,
      position: 'bottom',
      color: 'dark',
      buttons: [{ icon: 'close-outline', role: 'cancel' }]
    });
    toast.present();
  }
  async presentToastError(message: any) {
    const toast = await this.toastController.create({
      message: message,
      duration: 4500,
      position: 'bottom',
      color: 'dark',
      buttons: [{ icon: 'close-outline', role: 'cancel' }]
    });
    toast.present();
  }
  async presentToastWarning(message: any) {
    const toast = await this.toastController.create({
      message: message,
      duration: 4500,
      position: 'bottom',
      color: 'warning',
      cssClass: 'pf-toast-warning',
      buttons: [{ icon: 'close-outline', role: 'cancel' }]
    });
    toast.present();
  }
  // Maneja errores devueltos por la API. Para casos de conflicto suave
  // (ej. número celular duplicado) usa un toast warning con texto reescrito;
  // el resto se trata como error normal.
  presentApiErrorMessage(message: any) {
    const text = message == null ? '' : String(message);
    if (/ya hay un empleado registrado|n[uú]mero.*celular.*registrado/i.test(text)) {
      this.presentToastWarning('Ese número ya está en uso. Prueba con otro.');
      return;
    }
    this.presentToastError(message);
  }
  async presentAlert(header: string, message: string) {
    const alert = await this.alertController.create({
      header,
      message,
      buttons: ['OK']
    });

    await alert.present();
  }
  async presentLoading(m?: string) {
    this.loading = true;
    return await this.loadingCtrl.create({
      message: m,
    }).then(a => {
      a.present().then(() => {
        if (!this.loading) {
          a.dismiss().then(() => console.log());
        }
      });
    });
  }
  async dismissLoading() {
    this.loading = false;
    return await this.loadingCtrl.dismiss().then(() => console.log('dismissed'));
  }
  isFileVideo(path: string): boolean {
    const ext = path.endsWith('.mp4') || path.endsWith('.MOV') || path.endsWith('.webm');
    return ext
  }
  isFilePdf(path: string): boolean {
    const ext = path.substr(path.length - 4, path.length);
    return ext === '.pdf' ? true : false;
  }
  isFileExcel(path: string): boolean {
    const ext = path.endsWith('.xlsx') || path.endsWith('.xls');
    return ext
  }
  isFileWord(path: string): boolean {
    const ext = path.endsWith('.docx') || path.endsWith('.doc');
    return ext
  }
  isFilePowerPoint(path: string): boolean {
    const ext = path.endsWith('.ppt') || path.endsWith('.pptx');
    return ext
  }
  isFileImage(path: string): boolean {
    let lowerPath = path.toLocaleLowerCase()
    const ext = lowerPath.endsWith('.jpg') || lowerPath.endsWith('.jpeg') || lowerPath.endsWith('.png');
    return ext
  }
  isFileTxt(path: string): boolean {
    const ext = path.endsWith('.txt')
    return ext
  }
  isFileAudio(path: string): boolean {
    const ext = path.endsWith('.mp3') || path.endsWith('.aac') || path.endsWith('.wav') || path.endsWith('.flac') || path.endsWith('.m4a')
    return ext
  }

  getAudioType(fileName: string): string {
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'mp3':
        return 'audio/mpeg';
      case 'aac':
        return 'audio/aac';
      case 'wav':
        return 'audio/wav';
      case 'flac':
        return 'audio/flac';
      case 'm4a':
        return 'audio/mp4';
      default:
        return 'audio/wav';
    }
  }
  async openVideoPlayer(path_video: string, title_video?: string) {
    let modal = await this.modalController.create({
      component: VideoPlayerComponent,
      componentProps: {
        path_video,
        title_video
      }
    });
    modal.present();
  }
  async downloadFile(url, name, modeOffline = false) {
    if (!this.platform.is('cordova')) {
      window.open(url, '_blank');
      return
    }

    let mimeType = ''
    if (this.isFileExcel(url)) mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    else if (this.isFilePdf(url)) mimeType = 'application/pdf'
    else if (this.isFileWord(url)) mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    else if (this.isFilePowerPoint(url)) mimeType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    else if (this.isFileTxt(url)) mimeType = 'text/plain'
    else mimeType = 'image/' + this.getExtFromUrl(url)

    if (modeOffline) {
      this.fileOpener.open(url, mimeType)
        .then(() => {
          console.log("File is opened")
        })
        .catch(e => {
          const err = 'File opener Error status: ' + e.status + ' - Error message: ' + e.message
          this.presentToastError(err)
          console.log(err)
        });
      return
    }

    let path = await this.getDownloadPath()
    let final_path = path + name;
    await this.presentLoading()
    this.nativeHTTP.downloadFile(encodeURI(url), {}, {}, encodeURI(final_path)).then(response => {

      console.log('success', JSON.stringify(response));
      this.fileOpener.open(response.nativeURL, mimeType)
        .then(() => console.log("File is opened"))
        .catch(e => this.presentToastError('File opener Error status: ' + e.status + ' - Error message: ' + e.message));

    }).catch(err => {

      console.log('error block ... ', err.status);
      console.log('error block ... ', err.error);
    }).finally(() => {
      this.dismissLoading()
    })
  }
  async downloadShare(url, name) {
    if (!this.platform.is('cordova')) {
      return
    }
    this.presentLoading();
    let path = await this.getDownloadPath()
    let final_path = path + name;
    this.nativeHTTP.downloadFile(encodeURI(url), {}, {}, encodeURI(final_path)).then(response => {
      this.dismissLoading();
      console.log('success block...', JSON.stringify(response));
      this.socialSharing.share(null, null, response.nativeURL, null).then((data) => {
        console.log('Shared via SharePicker');
      }).catch((err) => {
        console.log('Was not shared via SharePicker', JSON.stringify(err))
      });
    }).catch(err => {
      this.dismissLoading();
      console.log('error block ... ', err.status);
      console.log('error block ... ', err.error);
    })
  }
  async getDownloadPath() {
    if (this.platform.is('ios')) {
      return this.file.documentsDirectory;
    }
    await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then(
      result => {
        if (!result.hasPermission) {
          return this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE);
        }
      }
    );
    return this.file.externalRootDirectory + "/Download/";
  }
  setErrMessage(msg: string) {
    this.errorMsg.next(msg);
  }
  setExistError(msg: boolean) {
    this.errorExist.next(msg);
  }
  getDifferenceInDays(date) {
    let date1 = new Date()
    let date2 = new Date(date)
    let difference_In_Time = date1.getTime() - date2.getTime();
    return Math.abs(Math.round(difference_In_Time / (1000 * 3600 * 24)) - 1);
  }
  openFile(data) {
    if (this.platform.is('cordova'))
      this.suaLetterService.createpdf(data.pdf_string, 'Carta SUA', data.id)
    else {
      this.suaLetterService.readSuaLetter(data.id);
      var contentType = "application/pdf";
      var dataBlob = this.suaLetterService.convertBase64ToBlob(data.pdf_string, contentType);
      window.open(URL.createObjectURL(dataBlob), '_system');
    }
  }
  async presentAlertCustom(header, message) {

    const alert = await this.alertController.create({
      cssClass: 'custom-alert',
      backdropDismiss: false,
      header,
      keyboardClose: false,
      subHeader: message,
      message: `<ion-row class="spinner"><ion-spinner></ion-spinner></ion-row>`,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => { },
        },
        {
          text: 'Aceptar',
          handler: async () => {

          },
        },
      ],
    });
    await alert.present();

  }
  async closeAlertCustom() {
    return await this.alertController.dismiss().then(() => console.log('dismissed'));
  }


  async toastCustom(msg, type) {
    let icon = `assets/imgs/capacitations/check-${type}.svg`
    const alert = await this.alertController.create({
      cssClass: `custom-alert ${type}`,
      backdropDismiss: false,
      keyboardClose: false,
      message: `<ion-row class="row-toast"><p class="msg"><ion-icon class="icon-toast" src="${icon}"></ion-icon>${msg}</p></ion-row>`,
      buttons: [

      ],
    });
    setTimeout(() => {
      this.closeAlertCustom()
    }, 2000)
    await alert.present();

  }
  sumDaysToDate(date, days) {
    const todayDate = new Date(date);
    const newDate = new Date(todayDate.getTime() + days * 24 * 60 * 60 * 1000);
    let month = newDate.toISOString().split('T')[0].split('-')[1];
    return newDate.getDate() + '/' + month + '/' + newDate.getFullYear();

  }
  createpdf(base64: any, name: string, type: string) {
    if (!this.platform.is('cordova')) {
      var dataBlob = this.convertBase64ToBlob(base64, type);
      window.open(URL.createObjectURL(dataBlob), '_system');
      return
    }
    const writeDirectory = this.platform.is('ios') ? this.file.dataDirectory : this.file.externalDataDirectory;
    this.file.writeFile(writeDirectory, name, this.convertBase64ToBlob(base64, type), { replace: true })
      .then((value) => {
        console.log('==> VALUIE', value);
        this.fileOpener.open(`${writeDirectory}${name}`, type)
          .then(() => console.log('File is opened'))
          .catch(e => console.log('Error opening file', JSON.stringify(e)));
      })
      .catch(() => {
        console.error('Error writing pdf file');
      });
  }
  convertBase64ToBlob(b64Data, contentType?: string): Blob {
    if (!contentType) {
      const match = b64Data.match(/^data:(.*?);base64,/);
      contentType = match ? match[1] : '';
    }
    const sliceSize = 512;
    b64Data = b64Data.replace(/^[^,]+,/, '');
    b64Data = b64Data.replace(/\s/g, '');
    const byteCharacters = window.atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
  }
  async openImageView(path: string, title?: string) {
    let modal = await this.modalController.create({
      component: ImageViewComponent,
      componentProps: {
        path,
        title
      }
    });
    modal.present();
  }
  startTimerOTP(duration, display, func: () => void, message: string) {

    let seconds;
    let currentSeconds = duration.toString()
    this.interval = setInterval(() => {
      seconds = parseInt((duration % 60).toString(), 10);
      seconds = seconds < 10 ? "0" + seconds : seconds;

      display.innerText = message.replace(currentSeconds, seconds)

      if (--duration < 0) {

        duration = 0;
        clearInterval(this.interval)
        func()
      }
    }, 1000);
  }
  emptyInterval() {
    clearInterval(this.interval)
  }
  getExtFromUrl(url) {
    const parts = url.split('.');
    if (parts.length > 1) {
      return parts.pop();
    }
    return '';
  }
  async blobToBase64(blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }
  async presentAlertOptions(header: string, message: string, func: () => any) {

    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header,
      keyboardClose: false,
      subHeader: message,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => { },
        },
        {
          text: 'Aceptar',
          handler: () => {
            func()
          },
        },
      ],
    });
    await alert.present();

  }
  getCurrentDate() {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    return `${day}/${month}/${year}`;
  }
  startEventKeyboardFab(renderer: Renderer2) {
    if (this.platform.is('cordova') && this.platform.is('android')) {
      const version = this.device.version;
      const majorVersion = parseInt(version.split('.')[0], 10);
      if (majorVersion == 15) {
        this.keyboardWillShowSubFab = this.keyboard.onKeyboardWillShow().subscribe(e => {
          const fab = document.querySelector('ion-fab');
          if (fab) {
            renderer.setStyle(fab, 'bottom', `${e.keyboardHeight + 16}px`);
          }
        });

        this.keyboardWillHideSubFab = this.keyboard.onKeyboardWillHide().subscribe(() => {
          const fab = document.querySelector('ion-fab');
          if (fab) {
            renderer.setStyle(fab, 'bottom', '32px');
          }
        });
      }
    }
  }
  stopEventKeyboardFab() {
    if (this.keyboardWillHideSubFab) this.keyboardWillHideSubFab.unsubscribe();
    if (this.keyboardWillShowSubFab) this.keyboardWillShowSubFab.unsubscribe();
  }
  startEventKeyboradModal(renderer: Renderer2) {
    if (this.platform.is('cordova') && this.platform.is('android')) {
      const version = this.device.version;
      const majorVersion = parseInt(version.split('.')[0], 10);
      if (majorVersion == 15) {
        this.keyboardWillShowSubModal = this.keyboard.onKeyboardWillShow().subscribe((e) => {
          renderer.setStyle(document.body, 'transform', `translateY(-${e.keyboardHeight}px)`);
        });

        this.keyboardWillHideSubModal = this.keyboard.onKeyboardWillHide().subscribe(() => {
          renderer.removeStyle(document.body, 'transform');
        });
      }
    }
  }
  stopEventKeyboardModal() {
    if (this.keyboardWillHideSubModal)
      this.keyboardWillHideSubModal.unsubscribe();
    if (this.keyboardWillShowSubModal)
      this.keyboardWillShowSubModal.unsubscribe();
  }
  dateFormatText() {
    const meses = [
      "enero", "febrero", "marzo", "abril", "mayo", "junio",
      "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ];

    const hoy = new Date();
    const dia = hoy.getDate();
    const mes = meses[hoy.getMonth()];
    const año = hoy.getFullYear();

    return `Ciudad de México a, ${dia} de ${mes} de ${año}`;
  }
  async selectFile(ev) {
    if (!ev['target'] || !ev['target']['files'] || !ev['target']['files'][0]) return
    let file = ev['target']['files'][0];

    //
    if (!this.isFileImage(file['name'])) {
      this.presentToastError('Ese formato de imagen no es válido. Usa JPG o PNG.')
      ev['target'].value = '';
      return
    }
    //
    const MAX_SIZE_MB = 20;
    const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;
    if (file.size > MAX_SIZE_BYTES) {
      this.presentToastError(
        `La imagen supera el tamaño máximo permitido (${MAX_SIZE_MB} MB)`,
      );
      ev['target'].value = '';
      return;
    }

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = async (e: any) => {
        ev['target'].value = '';
        resolve(e['target']['result']);
      };
      reader.onerror = async () => {
        ev['target'].value = '';
        reject(new Error('No pudimos leer el archivo. Inténtalo de nuevo.'))
      };

      reader.readAsDataURL(file);
    });
  }
  async getDownloadPathInner() {
    if (this.platform.is('ios')) {
      return this.file.documentsDirectory;
    }
    await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then(
      result => {
        if (!result.hasPermission) {
          return this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE);
        }
      }
    );
    return this.file.externalDataDirectory;
  }
  async internetOn(): Promise<boolean> {
    if (this.platform.is('cordova')) {
      const type = this.network.type;
      return type && type !== 'none' ? true : false;
    } else {
      return navigator.onLine;
    }
  }
  getFileType(fileName: string): string {
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'mp3':
        return 'audio/mpeg';
      case 'aac':
        return 'audio/aac';
      case 'wav':
        return 'audio/wav';
      case 'flac':
        return 'audio/flac';
      case 'm4a':
        return 'audio/mp4';
      case 'pdf':
        return 'application/pdf';
      case 'doc':
        return 'application/msword';
      case 'docx':
        return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      case 'xls':
        return 'application/vnd.ms-excel';
      case 'xlsx':
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg';
      case 'png':
        return 'image/png';
      case 'gif':
        return 'image/gif';
      case 'webp':
        return 'image/webp';
      default:
        return 'application/octet-stream';
    }
  }
  async alertTwoOptions(
    header: string,
    message: string,
    fn: () => Promise<void> | void
  ) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header,
      message,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => { },
        },
        {
          text: 'Continuar',
          handler: async () => {
            await fn();
          },
        },
      ],
    });

    await alert.present();
  }
  getCurrentDateCap() {
    const now = new Date();
    const dateStr =
      now.getFullYear() +
      '-' +
      String(now.getMonth() + 1).padStart(2, '0') +
      '-' +
      String(now.getDate()).padStart(2, '0') +
      ' ' +
      String(now.getHours()).padStart(2, '0') +
      ':' +
      String(now.getMinutes()).padStart(2, '0') +
      ':' +
      String(now.getSeconds()).padStart(2, '0');
    return dateStr
  }
  getNameBase64Image(base64Data): string {
    const match = base64Data.match(/^data:(image\/[a-zA-Z]+);base64,/);
    return match ? '.' + match[1].split('/')[1] : '.png';
  }
  openUrl(url, type) {
    if (this.platform.is("ios")) {
      this.options = {
        location: 'no',
        toolbarcolor: '#2196F3',
        toolbarposition: 'top',
        closebuttoncolor: '#ffffff',
        closebuttoncaption: 'Cerrar',
        lefttoright: "yes",
        hidenavigationbuttons: 'yes'
      };
    } else {
      this.options = {
        hideurlbar: 'yes',
        location: 'yes',
        toolbarcolor: '#2196F3',
        toolbarposition: 'top',
        closebuttoncolor: '#ffffff',
        closebuttoncaption: 'Cerrar',
        presentationstyle: 'pagesheet',
        hidenavigationbuttons: 'yes'
      };
    }
    const browser = this.iab.create(url, type, this.options);
  }
  async openYoutubePlayer(path_video: string, title_video?: string) {
    let modal = await this.modalController.create({
      component: YoutubePlayerComponent,
      componentProps: {
        path_video,
        title_video
      }
    });
    modal.present();
  }
}

